enum BillRelationshipType {
  Reintroduced = 'reintroduced',
  Omnibus = 'omnibus',
  HighlySimilar = 'similar',
  Unrelated = 'unrelated',
  Companion = 'companion',
}

export default BillRelationshipType;
